<template>
  <div class="system_serve_list">
    <!-- 渠道列表 -->
    <el-button class="search" type="primary" @click="addChannel"
      >添加渠道</el-button
    >
    <el-table
      class="table"
      :data="tableData"
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }"
      style="width: 98.5%; margin-top: 30px; margin-left: 10px"
      highlight-current-row
    >
      <el-table-column type="index" label="序号" width="130">
        <template slot-scope="scope">
          {{
            total - (queryData.pageNum - 1) * queryData.pageSize - scope.$index
          }}
        </template>
      </el-table-column>
      <el-table-column prop="employeeName" label="客服名称" />
      <el-table-column prop="appName" label="项目名称" />
      <el-table-column prop="status" label="渠道状态">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            inactive-color="#A4B8CF"
            active-value="1"
            inactive-value="0"
            @change="changestatus($event, scope.row, scope.$index)"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="235">
        <template slot-scope="scope">
          <el-button
            v-clipboard:copy="ImLink + '?id=' + scope.row.employeeId + '&appId=' + scope.row.appName "
            type="text"
            size="small"
            class="edeit"
            @click="copy"
            >复制链接</el-button
          >
          <el-button
            type="text"
            size="small"
            class="edeit"
            @click="handleEdit(scope.row)"
            >修改</el-button
          >
          <el-button
            type="text"
            size="small"
            class="edeit"
            @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      background
      :current-page="queryData.pageNum"
      :page-sizes="[15, 30, 50, 100, 200]"
      :page-size="queryData.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!-- 添加弹框 -->
    <el-dialog :title="title" :visible.sync="adddialogFormVisible" width="30%">
      <el-form ref="form" :model="form" label-width="110px" class="proeditform">
        <!-- <el-form-item label="客服名称:">
          <el-input v-model="form.userName" />
        </el-form-item> -->
        <el-form-item label="项目名称:">
          <el-input v-model="form.appName" />
        </el-form-item>
        <el-form-item label="客服名称:" v-if="roleCode == 'admin'">
          <el-select
            v-model="form.employeeId"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              :label="item.userName"
              :value="item.id"
              v-for="(item, index) in kefuTableData"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="渠道状态:">
          <el-select
            v-model="form.status"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option label="开启" value="1" />
            <el-option label="关闭" value="0" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel" @click="adddialogFormVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="adddialogFormVisibleClk"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { get, post } from "@/utils/request";
import { getToken } from "@/utils/auth";
import axios from "axios";
import sha256 from "crypto-js/sha256";

export default {
  name: "",
  components: {},
  data() {
    return {
      title: "",
      url: "",
      adddialogFormVisible: false,
      tableData: [],
      kefuTableData: [],
      ImLink:'https://guide.ytcfk.top/im',
      queryData: {
        pageNum: 1,
        pageSize: 15,
      },
      form: {
        employeeId: "", //客服的id
        // userName: "", // 渠道名称
        appName: "", //项目名称
        status: "", // 状态
      },
      total: 0,
      sysVal: "",
      urlCeshi: "",
      roleCode: "",
    };
  },
  created() {
    this.roleCode = sessionStorage.getItem("roleCode");
    this.getList();
    this.getAllKefu();
  },
  methods: {
    // 获取所有的客服
    getAllKefu() {
      post("/admin/employee/findPage", this.queryData).then((res) => {
        this.kefuTableData = res.data.data.list;
      });
    },
    addChannel() {
      this.form = {};
      this.title = '添加'
      this.adddialogFormVisible = true;
    },
    copy(row) {
      this.$message.success("复制成功");
    },
    handleDel(row) {
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const id = row.id;
        post("/admin/imchannel/delete", { id }).then((res) => {
          if (res.data.code != 20000) {
            this.$message({
              type: "info",
              message: res.data.message,
            });
          } else {
            this.getList();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          }
        });
      });
    },
    changestatus(status, data, index) {
      post("/admin/imchannel/update", data).then((res) => {
        if (res.data.code != 20000) {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        } else {
          this.$message({
            message: res.data.message,
            type: "success",
          });
          this.getList();
        }
      });
    },
    adddialogFormVisibleClk() {
      this.adddialogFormVisible = false;

      if (this.title == "添加") {
        post("/admin/imchannel/add", this.form).then((res) => {
          if (res.data.code != 20000) {
            this.$message({
              type: "info",
              message: res.data.message,
            });
          } else {
            this.$message({
              type: "success",
              message: "请求成功!",
            });
            this.getList();
          }
        });
      } else {
        post("/admin/imchannel/update", this.form).then((res) => {
          if (res.data.code != 20000) {
            this.$message({
              type: "info",
              message: res.data.message,
            });
          } else {
            this.$message({
              type: "success",
              message: "请求成功!",
            });
            this.getList();
          }
        });
      }
    },
    handleEdit(row) {
      this.title = "编辑";
      this.adddialogFormVisible = true;
      this.form.employeeId = row.id;
      this.form.appName = row.appName;
      this.form.status = row.status;

    },
    clear() {
      this.getList();
    },
    handleSizeChange(val) {
      this.queryData.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.getList();
    },
    getList() {
      post("/admin/imchannel/page", this.queryData).then((res) => {
        this.tableData = res.data.data.data;
        this.total = res.data.data.total;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-upload-dragger {
  width: 200px;
  height: 200px;
}
.pica {
  width: 200px;
  height: 200px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
